import {
	Box,
	Button,
	Card,
	CardContent,
	CircularProgress,
	IconButton,
	InputAdornment,
	OutlinedInput,
	Stack,
	TextField,
	Typography,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import Lottie from "react-lottie";
import AppChatBar from "../components/AppChatBar";
import {
	EnumAccompanyType,
	EnumActionConversation,
	EnumQuestionType,
	EnumStatusCode,
} from "../enums/chat.enums";
import {
	Conversation,
	Message,
	OptionEvaluation,
	Topic,
	UserResponse,
} from "../interfaces/chat.interface";
import ChatService from "../services/chat-service";
import studaLoad from "../../../assets/lotties/load.json";
import studaLoad2 from "../../../assets/lotties/load-small.json";
import "./css/conversation.scss";
import { setCurrentConversation } from "../../../store/slices/conversationSlice";
import { useDispatch, useSelector } from "react-redux";
import InfiniteScroll from "react-infinite-scroll-component";
import {
	RestartAlt,
	Send,
	SendOutlined,
	VerticalAlignCenter,
	WorkspacePremium,
} from "@mui/icons-material";

import { setCurrentSubject } from "../../../store/slices/subjectSlice";
import { IMuiFbPhotoGridImage, MuiFbPhotoGrid } from "mui-fb-photo-grid";
import KEYS from "../../../helpers/KEYS";
import { setCurrentMenu } from "../../../store/slices/menuSlice";
import { selectCurrentMode } from "../../../store/slices/modeSlice";
import {
	selectConversationsList,
	setConversationsList,
} from "../../../store/slices/conversationsSlice";
import { setCurrentLoading } from "../../../store/slices/loadingSlice";

function ConversationScreen({ conversationSelected, theme }: any) {
	const dispatch = useDispatch();

	const loadOptions = {
		loop: true,
		autoplay: true,
		animationData: studaLoad,
		rendererSettings: {
			preserveAspectRatio: "xMidYMid slice",
		},
	};
	const loadOptions2 = {
		loop: true,
		autoplay: true,
		animationData: studaLoad2,
		rendererSettings: {
			preserveAspectRatio: "xMidYMid slice",
		},
	};
	const bottomRef = useRef<null | HTMLElement>(null);
	const [subject, setSubject] = React.useState<Topic>(
		conversationSelected.subject ?? null
	);
	const [actionConversation, setActionConversation] =
		React.useState<EnumActionConversation>(conversationSelected.action ?? null);
	let tmpMessages: Message[] = [];
	const [lastEvaluatedKey, setLastEvaluatedKey] = React.useState<any>();
	const [messages, setMessages] = React.useState<Message[]>([]);
	const [conversation, setConversation] = React.useState<Conversation>();
	const [currentMessageQuestion, setCurrentMessageQuestion] =
		React.useState<Message | null>();

	const [progressStart, setProgressStart] = React.useState<boolean>(false);
	const [progressContinue, setProgressContinue] =
		React.useState<boolean>(false);
	const [hasMoreMessage, setHasMoreMessage] = React.useState<boolean>(false);

	const [poressSending, setProgressSending] = React.useState<boolean>(false);

	const [answerString, setAnswerString] = React.useState<string>();

	const [hasSubscription, setHasSubscription] = React.useState<boolean>(true);
	const [hasReachedEnd, setHasReachedEnd] = React.useState<boolean>(false);
	const [messageSubscription, setMessageSubscription] = React.useState<
		Message[]
	>([]);
	const conversationList = useSelector(selectConversationsList);

	const letters = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J"];
	useEffect(() => {
		setSubject(conversationSelected.subject);
		setActionConversation(conversationSelected.action);
		setMessages([]);
		setHasSubscription(true);
		setHasReachedEnd(false);

		if (conversationSelected.action) {
			// mise a jour du loading dans la store pour empecher qu'on accède à une autre conversation avant la fin de celle ci
			dispatch(setCurrentLoading({ loading: true }));
			if (
				conversationSelected.action ===
				EnumActionConversation.START_CONVERSATION
			) {
				startConversation();
			} else if (
				conversationSelected.action ===
				EnumActionConversation.CONTINUE_CONVERSATION
			) {
				continueConversation();
			} else if (
				conversationSelected.action ===
				EnumActionConversation.RESTART_CONVERSATION
			) {
				restartConversation();
			} else if (
				conversationSelected.action ===
				EnumActionConversation.BROWSE_CONVERSATION
			) {
				browseConversation();
			}
		}
	}, [conversationSelected]);

	useEffect(() => {
		bottomRef.current?.scrollIntoView(true);
	}, [progressContinue]);
	const selectOptionMessage = (message: Message) => {
		let newMessages = messages.map((element: Message) => {
			if (element.messageId === message.messageId) return message;
			return element;
		});
		setMessages(newMessages);
	};

	const startConversation = async () => {
		setProgressStart(true);
		await ChatService.startConversation(
			conversationSelected.subject.path ?? "",
			"fr"
		)
			.then(
				(result: any) => {
					if (
						result.code === EnumStatusCode.SUCCESS &&
						result.statusCode === EnumStatusCode.SUCCESS
					) {
						const newConversation = result.data.conversation;
						const goodTopicLabel = newConversation.topicLabel.filter(
							(element: string) => element != null
						);
						newConversation.topicLabel = goodTopicLabel;
						setConversation(newConversation);
						console.log("Ce qui est envoye ", newConversation);
						let filterConversationsList: Conversation[] = [];
						if (conversationList.length > 0) {
							filterConversationsList = [...conversationList];
						}

						filterConversationsList.unshift(newConversation);
						console.log("apres l'envoie ", filterConversationsList);
						dispatch(setConversationsList(filterConversationsList));
						let newMessages = result.data.messages;
						if (!newMessages[0].type) newMessages.shift(); //remove first message empty
						newMessages = newMessages.map((e: Message) => {
							if (e.type === EnumAccompanyType.QUESTION && e.userAnswer == null)
								setCurrentMessageQuestion(e);

							//Récupération des options d'évaluation
							if (e.options != null && e.options.length > 0) {
								let myOptions: number[] = [];
								let myOption: number = -1;
								if (e.userAnswer != null) {
									if (e.question?.type === EnumQuestionType.MULTI_CHOICE)
										myOptions = e.userAnswer["options"];
									if (e.question?.type === EnumQuestionType.SINGLE_CHOICE)
										myOption = e.userAnswer["option"];
									//console.log("une option :", message.userAnswer["option"]);
								}

								e.optionsEvaluation = [];
								let index = 0;
								e.options.forEach((element: string) => {
									let optionEvaluation: OptionEvaluation =
										new OptionEvaluation();
									optionEvaluation.content = element;
									optionEvaluation.isChecked =
										myOptions?.includes(index) || myOption === index;
									index++;
									e.optionsEvaluation?.push(optionEvaluation);
								});
							}
							tmpMessages.push(e);
							return e;
						});

						let newSubject: Topic = {
							conversationId: newConversation.conversationId,
							path: newConversation.path,
							progression: newConversation.progression,
							name:
								newConversation.topicLabel !== undefined
									? newConversation.topicLabel[
											newConversation.topicLabel.length - 1
									  ]
									: "",
							totalQuestions: newConversation.totalQuestions,
							code: conversationSelected.subject.code,
						};

						/*let newSubject = { ...conversationSelected.subject };
						newSubject.conversationId = result.data.conversation.conversationId;
						newSubject.totalQuestions = result.data.conversation.totalQuestions;*/
						let progression = {
							note: 0,
							progression: 0,
							totalNote: 0,
							questionsVisited: 1,
						};
						newSubject.progression = progression;
						setSubject(newSubject);
						console.log(newSubject);
						dispatch(
							setCurrentSubject({
								subject: newSubject,
								action: EnumActionConversation.CONTINUE_CONVERSATION,
							})
						);

						dispatch(
							setCurrentConversation({
								subject: newSubject,
								action: "",
							})
						);
						dispatch(setCurrentMenu({ title: "", code: 0 }));
						writeAllMessages(EnumActionConversation.START_CONVERSATION);
						//console.log(result);
						setProgressStart(false);
					} else {
						console.log("il y'a errreururururur");
					}
				},
				(error: any) => {
					console.log(error);
				}
			)
			.finally(() => {
				setProgressStart(false);
				dispatch(setCurrentLoading({ loading: false }));
			});
	};
	const confirmChoice = (newMessage: Message) => {
		let optionEvaluation = newMessage.optionsEvaluation;
		let answerString = "";
		let answersArray: number[] = [];
		if (optionEvaluation) {
			let nb = optionEvaluation.filter(
				(element) => element.isChecked === true
			).length;
			let choix = "";
			for (let i = 0; i < optionEvaluation.length; i++) {
				if (optionEvaluation[i].isChecked) {
					choix = choix.length > 0 ? choix + "," + letters[i] : letters[i];
					answersArray.push(i);
				}
			}

			if (nb === 1) answerString = "Je choisis l'option: " + choix;
			else answerString = "Je choisis les options: " + choix;
		}
		let userResponse: UserResponse = new UserResponse();
		userResponse.answersArray = answersArray;
		userResponse.content = answerString;
		setCurrentMessageQuestion(null);
		sendResponseUser(userResponse);
	};
	const sendResponseUser = async (answer?: UserResponse) => {
		try {
			let responseData = {
				conversationId:
					conversationSelected.subject.conversationId ??
					conversation?.conversationId,
				messageId: currentMessageQuestion?.messageId,
				answer: answer,
				lang: "fr",
			};
			let message: Message = new Message();
			message.conversationId = conversationSelected.subject.conversationId;
			message.position = 2;
			message.type = EnumAccompanyType.ANSWER;
			message.answerString = answer?.content;
			message.messageId = new Date().getTime();
			tmpMessages.push(message);
			writeAllMessages(EnumActionConversation.RESPONSE_CONVERSATION);
			setProgressSending(true);
			console.log("La valeur de answer", answer);
			const result = await ChatService.sendUserResponse(responseData);
			console.log("le resultat ", result);
			if (result.statusCode == EnumStatusCode.SUCCESS) {
				/************Controle sur la subscription et la fin de la conversation *****************/
				const messages = result.data.messages;

				let msgSubscriptions: Message[] = [];
				messages.forEach((message: Message) => {
					if (message.type === EnumAccompanyType.SUBSCRIPTION) {
						setHasSubscription(false);
						msgSubscriptions.push(message);
					}
					if (message.type === EnumAccompanyType.SUBSCRIPTION_INFO) {
						msgSubscriptions.push(message);
					}

					if (message.type === EnumAccompanyType.END_CONVERSATION) {
						setHasReachedEnd(true);
					}
				});
				setMessageSubscription(msgSubscriptions);
				/******************************fin de controle *******************************************/

				const resultMessages = result.data.messages;

				const conversationListUpdated = conversationList.map(
					(conversation: Conversation) => {
						let element = {
							...conversation,
							lastMessage:
								conversation.lastMessage && conversation.lastMessage != null
									? conversation.lastMessage
									: null,
						};
						if (
							conversation.conversationId ===
							conversationSelected.subject.conversationId
						) {
							element.lastMessage = resultMessages[resultMessages.length - 1];
						}
						return element;
					}
				);

				let filterConversationsList: Conversation[] =
					conversationListUpdated.sort((a: Conversation, b: Conversation) => {
						if (a.lastMessage?.createdAt && b.lastMessage?.createdAt) {
							if (a.lastMessage?.createdAt < b.lastMessage?.createdAt) return 1;
							if (a.lastMessage?.createdAt > b.lastMessage?.createdAt)
								return -1;
							return 0;
						} else return 0;
					});

				//let faildMessage = "";
				let newMessages = result.data.messages;
				//TODO: if (!newMessages[0].type) newMessages.shift(); //remove first message empty Problème du backend
				console.log(newMessages);
				let newSubject: Topic = {
					...conversationSelected.subject,
					totalQuestions: conversation?.totalQuestions ?? 0,
				};

				newMessages = newMessages.map((e: Message) => {
					tmpMessages.push(e);

					if (e.type === EnumAccompanyType.QUESTION && e.userAnswer == null)
						setCurrentMessageQuestion(e);

					//Récupération des options d'évaluation
					if (e.options != null && e.options.length > 0) {
						let myOptions: number[] = [];
						let myOption: number = -1;
						if (e.userAnswer != null) {
							if (e.question?.type === EnumQuestionType.MULTI_CHOICE)
								myOptions = e.userAnswer["options"];
							if (e.question?.type === EnumQuestionType.SINGLE_CHOICE)
								myOption = e.userAnswer["option"];
						}

						e.optionsEvaluation = [];
						let index = 0;
						e.options.forEach((element: string) => {
							let optionEvaluation: OptionEvaluation = new OptionEvaluation();
							optionEvaluation.content = element;
							optionEvaluation.isChecked =
								myOptions?.includes(index) || myOption === index;
							index++;
							e.optionsEvaluation?.push(optionEvaluation);
						});
					}

					//Mise en commun des message de type Failed evaluation et correction
					if (e.type === EnumAccompanyType.FAILED_EVALUATION) {
						//faildMessage = e.content?.message ?? "";
						let progression = {
							note: e.content?.note,
							progression: e.content?.progression,
							totalNote: e.content?.totalNote,
							questionsVisited: e.content?.questionsVisited,
						};
						newSubject.progression = progression;

						setSubject(newSubject);

					} else {
						/*if (e.type === EnumAccompanyType.CORRECTION) {
							if (e.content) e.content.faildMessage = faildMessage;
						}*/
						if (e.type === EnumAccompanyType.SUCESS_EVALUATION) {
							let progression = {
								note: e.content?.note,
								progression: e.content?.progression,
								totalNote: e.content?.totalNote,
								questionsVisited: e.content?.questionsVisited,
							};

							newSubject.progression = progression;
							setSubject(newSubject);
						}
						// if (
						// 	e.type !== EnumAccompanyType.SUBSCRIPTION &&
						// 	e.type !== EnumAccompanyType.END_CONVERSATION
						// )
						// 	tmpMessages.push(e);
					}
					return e;
				});

				writeAllMessages(EnumActionConversation.RESPONSE_CONVERSATION);
				dispatch(setConversationsList(filterConversationsList));
			}
			setProgressSending(false);
		} catch (error) {
			setProgressSending(false);
		}
	};
	const restartConversation = async () => {
		dispatch(setCurrentMenu({ title: "", code: 0 }));
		try {
			setProgressStart(true);
			console.log(conversationSelected);
			const result = await ChatService.restartConversation(
				conversationSelected?.subject.conversationId ?? ""
			);

			if (result && result.statusCode === EnumStatusCode.SUCCESS) {
				let foundSubscription = false;
				let foundEndConversation = false;
				let msgSubscriptions: Message[] = [];
				result.data.messages.forEach((message: Message) => {
					if (message.type === EnumAccompanyType.SUBSCRIPTION) {
						setHasSubscription(false);
						foundSubscription = true;
						msgSubscriptions.push(message);
					}
					if (message.type === EnumAccompanyType.SUBSCRIPTION_INFO) {
						msgSubscriptions.push(message);
					}

					if (message.type === EnumAccompanyType.END_CONVERSATION) {
						setHasReachedEnd(true);
						foundEndConversation = true;
					}
				});
				setMessageSubscription(msgSubscriptions);
				setHasSubscription(!foundSubscription);
				setHasReachedEnd(foundEndConversation);

				let newMessages = result.data.messages;
				if (!newMessages[0].type) newMessages.shift(); //remove first message empty
				newMessages = newMessages.map((e: Message) => {
					if (e.type === EnumAccompanyType.QUESTION && e.userAnswer == null)
						setCurrentMessageQuestion(e);

					//Récupération des options d'évaluation
					if (e.options != null && e.options.length > 0) {
						let myOptions: number[] = [];
						let myOption: number = -1;
						if (e.userAnswer != null) {
							if (e.question?.type === EnumQuestionType.MULTI_CHOICE)
								myOptions = e.userAnswer["options"];
							if (e.question?.type === EnumQuestionType.SINGLE_CHOICE)
								myOption = e.userAnswer["option"];
						}

						e.optionsEvaluation = [];
						let index = 0;
						e.options.forEach((element: string) => {
							let optionEvaluation: OptionEvaluation = new OptionEvaluation();
							optionEvaluation.content = element;
							optionEvaluation.isChecked =
								myOptions?.includes(index) || myOption === index;
							index++;
							e.optionsEvaluation?.push(optionEvaluation);
						});
					}
					tmpMessages.push(e);
					// if (
					// 	e.type !== EnumAccompanyType.SUBSCRIPTION &&
					// 	e.type !== EnumAccompanyType.END_CONVERSATION
					// )
					// 	tmpMessages.push(e);
					return e;
				});

				let newSubject = { ...conversationSelected.subject };
				setSubject(conversationSelected?.subject);
				console.log(newSubject);
				dispatch(
					setCurrentSubject({
						subject: newSubject,
						action: EnumActionConversation.CONTINUE_CONVERSATION,
					})
				);
			}
			writeAllMessages(EnumActionConversation.START_CONVERSATION);
			setProgressStart(false);
		} catch (error) {
			setProgressStart(false);
		}
	};
	const continueConversation = async () => {
		try {
			setProgressStart(true);
			const resultStart = await ChatService.startConversation(
				conversationSelected.subject.path ?? "",
				"fr"
			);
			if (resultStart.statusCode === EnumStatusCode.SUCCESS) {
				const infoConversation = resultStart.data.conversation;
				const messages = resultStart.data.messages;
				let foundSubscription = false;
				let foundEndConversation = false;
				let msgSubscriptions: Message[] = [];
				console.log("les messages ", messages);
				resultStart.data.messages.forEach((message: Message) => {
					if (message.type === EnumAccompanyType.SUBSCRIPTION) {
						setHasSubscription(false);
						foundSubscription = true;
						msgSubscriptions.push(message);
					}
					if (message.type === EnumAccompanyType.SUBSCRIPTION_INFO) {
						msgSubscriptions.push(message);
					}

					if (message.type === EnumAccompanyType.END_CONVERSATION) {
						setHasReachedEnd(true);
						foundEndConversation = true;
					}
				});
				setMessageSubscription(msgSubscriptions);
				setHasSubscription(!foundSubscription);
				setHasReachedEnd(foundEndConversation);
			}
			setProgressStart(false);
			setProgressContinue(true);
			const result = await ChatService.loadHistory(
				conversationSelected.subject.conversationId ?? ""
			);
			dispatch(setCurrentLoading({ loading: false }));
			if (result && result.statusCode === EnumStatusCode.SUCCESS) {
				setLastEvaluatedKey(result.data.lastEvaluatedKey);

				setConversation(result.data.conversation);
				//let faildMessage: string = "";
				result.data.messages.reverse().forEach((message: Message) => {
					//Définition de la question courante
					if (
						message.type === EnumAccompanyType.QUESTION &&
						message.userAnswer == null
					)
						setCurrentMessageQuestion(message);
					//Récupération des options d'évaluation
					if (message.options != null && message.options.length > 0) {
						let myOptions: number[] = [];
						let myOption: number = -1;
						if (message.userAnswer != null) {
							if (message.question?.type === EnumQuestionType.MULTI_CHOICE)
								myOptions = message.userAnswer["options"];
							if (message.question?.type === EnumQuestionType.SINGLE_CHOICE)
								myOption = message.userAnswer["option"];
						}

						message.optionsEvaluation = [];
						let index = 0;
						message.options.forEach((element: string) => {
							let optionEvaluation: OptionEvaluation = new OptionEvaluation();
							optionEvaluation.content = element;
							optionEvaluation.isChecked =
								myOptions?.includes(index) || myOption === index;
							index++;
							message.optionsEvaluation?.push(optionEvaluation);
						});
						console.log("le message ", message.optionsEvaluation);
					}
					//Mise en commun des message de type Failed evaluation et correction
					/*if (message.type === EnumAccompanyType.FAILED_EVALUATION) {
						faildMessage = message.content?.message ?? "";
					} else {
						if (message.type === EnumAccompanyType.CORRECTION) {
							if (message.content) message.content.faildMessage = faildMessage;
						}
						if (
							message.type !== EnumAccompanyType.SUBSCRIPTION &&
							message.type !== EnumAccompanyType.END_CONVERSATION
						)
							tmpMessages.push(message);
					}*/
					if (
						message.type !== EnumAccompanyType.SUBSCRIPTION &&
						message.type !== EnumAccompanyType.END_CONVERSATION
					)
						tmpMessages.push(message);
				});
				let oldTmpMessages = [...tmpMessages];
				tmpMessages = oldTmpMessages.reverse();

				let moreMessage =
					result.data.lastEvaluatedKey != null &&
					result.data.lastEvaluatedKey.messageId != null;
				setHasMoreMessage(moreMessage);
				dispatch(
					setCurrentSubject({
						subject: conversationSelected.subject,
						action: conversationSelected.action,
					})
				);
				dispatch(
					setCurrentConversation({
						subject: conversationSelected.subject,
						action: EnumActionConversation.RESPONSE_CONVERSATION,
					})
				);
			}
			dispatch(setCurrentMenu({ title: "", code: 0 }));
			setProgressContinue(false);
			writeAllMessages(EnumActionConversation.CONTINUE_CONVERSATION);
		} catch (error) {
			setProgressStart(false);
			setProgressContinue(false);
			dispatch(setCurrentLoading({ loading: false }));
		}
	};
	const browseConversation = async () => {
		try {
			setProgressContinue(true);
			const result = await ChatService.loadHistory(
				conversationSelected.subject.conversationId ?? ""
			);
			dispatch(setCurrentLoading({ loading: false }));
			if (result && result.statusCode === EnumStatusCode.SUCCESS) {
				setLastEvaluatedKey(result.data.lastEvaluatedKey);

				setConversation(result.data.conversation);
				//let faildMessage: string = "";
				result.data.messages.reverse().forEach((message: Message) => {
					//Définition de la question courante
					if (
						message.type === EnumAccompanyType.QUESTION &&
						message.userAnswer == null
					)
						setCurrentMessageQuestion(message);
					//Récupération des options d'évaluation
					if (message.options != null && message.options.length > 0) {
						let myOptions: number[] = [];
						let myOption: number = -1;
						if (message.userAnswer != null) {
							if (message.question?.type === EnumQuestionType.MULTI_CHOICE)
								myOptions = message.userAnswer["options"];
							if (message.question?.type === EnumQuestionType.SINGLE_CHOICE)
								myOption = message.userAnswer["option"];
							//console.log("une option :", message.userAnswer["option"]);
						}

						message.optionsEvaluation = [];
						let index = 0;
						message.options.forEach((element: string) => {
							let optionEvaluation: OptionEvaluation = new OptionEvaluation();
							optionEvaluation.content = element;
							optionEvaluation.isChecked =
								myOptions?.includes(index) || myOption === index;
							index++;
							message.optionsEvaluation?.push(optionEvaluation);
						});
						console.log("le message ", message.optionsEvaluation);
					}
					//Mise en commun des message de type Failed evaluation et correction
					/*if (message.type === EnumAccompanyType.FAILED_EVALUATION) {
						faildMessage = message.content?.message ?? "";
					} else {
						if (message.type === EnumAccompanyType.CORRECTION) {
							if (message.content) message.content.faildMessage = faildMessage;
						}
						if (
							message.type !== EnumAccompanyType.SUBSCRIPTION &&
							message.type !== EnumAccompanyType.END_CONVERSATION
						)
							tmpMessages.push(message);
					}*/
					
					// if (
					// 	message.type !== EnumAccompanyType.SUBSCRIPTION &&
					// 	message.type !== EnumAccompanyType.END_CONVERSATION
					// )
					// 	tmpMessages.push(message);
					tmpMessages.push(message);
				});
				let oldTmpMessages = [...tmpMessages];
				tmpMessages = oldTmpMessages.reverse();

				let moreMessage =
					result.data.lastEvaluatedKey != null &&
					result.data.lastEvaluatedKey.messageId != null;
				setHasMoreMessage(moreMessage);
				dispatch(
					setCurrentSubject({
						subject: conversationSelected.subject,
						action: conversationSelected.action,
					})
				);
			}

			setProgressContinue(false);
			writeAllMessages(EnumActionConversation.CONTINUE_CONVERSATION);
		} catch (error) {
			setProgressStart(false);
			setProgressContinue(false);
		}
	};
	const fetchMoreData = async () => {
		const result = await ChatService.loadHistory(
			conversationSelected.subject.conversationId ?? "",
			lastEvaluatedKey?.messageId
		);
		if (result && result.statusCode === EnumStatusCode.SUCCESS) {
			setLastEvaluatedKey(result.data.lastEvaluatedKey);
			setConversation(result.data.conversation);
			//let faildMessage: string = "";
			result.data.messages.forEach((message: Message) => {
				tmpMessages.push(message);
				//Mise en commun des message de type Failed evaluation et correction
				/*if (message.type === EnumAccompanyType.FAILED_EVALUATION) {
					faildMessage = message.content?.message ?? "";
				} else {
					if (message.type === EnumAccompanyType.CORRECTION) {
						if (message.content) message.content.faildMessage = faildMessage;
					}
					if (
						message.type !== EnumAccompanyType.SUBSCRIPTION &&
						message.type !== EnumAccompanyType.END_CONVERSATION
					)
						tmpMessages.push(message);
				}*/
			});

			let moreMessage =
				result.data.lastEvaluatedKey != null &&
				result.data.lastEvaluatedKey.messageId != null;
			setHasMoreMessage(moreMessage);
		}
		writeAllMessages(EnumActionConversation.CONTINUE_CONVERSATION);
	};
	const writeAllMessages = (actionConversation: EnumActionConversation) => {
		console.log("Les messages ", tmpMessages);
		if (actionConversation === EnumActionConversation.START_CONVERSATION) {
			let allMessages: Message[] = [];
			tmpMessages.forEach((element: Message) => {
				allMessages = [...allMessages, element];
				if (element.type === EnumAccompanyType.QUESTION) {
					if (element.userAnswer === null) setCurrentMessageQuestion(element);
				}
			});
			tmpMessages = [];
			setMessages(allMessages.reverse());
		} else if (
			actionConversation === EnumActionConversation.CONTINUE_CONVERSATION
		) {
			let isSameSubject = conversationSelected.subject.path === subject.path;
			console.log("Is sameSubject ", isSameSubject);
			let allMessages: Message[] = isSameSubject ? messages : [];
			console.log("Is sameSubject ", tmpMessages);
			tmpMessages.forEach((element: Message) => {
				allMessages.push(element);

				if (element.type === EnumAccompanyType.QUESTION) {
					if (element.userAnswer === null) setCurrentMessageQuestion(element);
				}
			});
			tmpMessages = [];
			setMessages(allMessages);
		} else if (
			actionConversation === EnumActionConversation.RESPONSE_CONVERSATION
		) {
			let isSameSubject = conversationSelected.subject.path === subject.path;
			let allMessages: Message[] = isSameSubject ? messages : [];
			console.log("Is sameSubject ", allMessages);
			tmpMessages.forEach((element: Message) => {
				allMessages.unshift(element);

				if (element.type === EnumAccompanyType.QUESTION) {
					if (element.userAnswer === null) setCurrentMessageQuestion(element);
				}
			});
			tmpMessages = [];
			console.log("after ", allMessages);
			setMessages(allMessages);
		}
	};
	const mode = useSelector(selectCurrentMode);

	return (
		<div className="conversation-screen">
			{/*<AppToolBar />*/}
			<div className="conversation-app-bar">
				<AppChatBar
					title={subject.name ?? ""}
					totalQuestions={subject.totalQuestions ?? 0}
					progression={subject.progression}
					theme={theme}
				/>
			</div>
			<div className="content-conversation">
				{mode === "dark" && (
					<div
						className="absolute-bg"
						style={{
							backgroundColor:
								mode === "dark" ? theme.palette.contentbox.dark : "transparent",
						}}
					></div>
				)}
				{!progressStart ? (
					<div
						style={{
							display: "flex",
							flexDirection: "column-reverse",
							justifyContent: "flex-end",
						}}
					>
						<Box
							id="scrollableDiv"
							ref={bottomRef}
							className="wrap-chat"
							sx={{
								display: "flex",
								flexDirection: "column-reverse",

								overflow: "hidden",
								scrollbarWidth: "thin",

								height: "calc(100vh - 160px)",

								"&::-webkit-scrollbar": {
									width: "0.2em",
								},
								"&::-webkit-scrollbar-track": {
									background: "#f1f1f1",
								},
								"&::-webkit-scrollbar-thumb": {
									backgroundColor: "#888",
								},
								"&::-webkit-scrollbar-thumb:hover": {
									background: "#555",
								},
								"&:hover": {
									overflow: "auto !important",
								},
							}}
						>
							<div
								style={{ display: "flex", maxHeight: "100%", flex: "1 1 auto" }}
							></div>
							{!progressContinue ? (
								<Box
									sx={{
										display: "flex",
										flexDirection: "column",
										flex: "0 1 auto",
									}}
								>
									<InfiniteScroll
										dataLength={messages.length}
										next={fetchMoreData}
										style={{
											display: "flex",
											flexDirection: "column-reverse",
											overflow: "hidden",
										}} //To put endMessage and loader to the top.
										inverse={true} //
										hasMore={hasMoreMessage}
										loader={
											<div
												style={{ display: "flex", justifyContent: "center" }}
											>
												<CircularProgress />
											</div>
										}
										scrollableTarget="scrollableDiv"
									>
										{messages.map((message, index) => (
											<div
												key={message.messageId}
												style={{
													paddingTop: "3px",
													paddingBottom: "3px",
													position: "relative",
												}}
											>
												<ChatBox
													message={message}
													currentMessageQuestion={currentMessageQuestion}
													onSelectOptionMessage={(messageUpdate) => {
														selectOptionMessage(messageUpdate);
													}}
													sendMyChoice={(message) => {
														confirmChoice(message);
													}}
													theme={theme}
													mode={mode}
												/>
											</div>
										))}
									</InfiniteScroll>
									{poressSending && (
										<div
											className=""
											style={{
												display: "flex",
												justifyContent: "flex-start",
												alignItems: "center",
												backgroundColor:
													mode === "dark"
														? theme.palette.leftbar.dark
														: "white",
												paddingLeft: "10px",
												paddingRight: "10px",
												paddingTop: "10px",
												paddingBottom: "10px",
												maxWidth: "130px",
												borderRadius: "10px",
												color:
													mode === "dark"
														? theme.palette.colortext.dark
														: theme.palette.colortext.light,
												fontSize: "14px",
												marginLeft: "10px",
												marginBottom: "15px",
												marginTop: "15px",
												position: "relative",
												zIndex: 999,
											}}
										>
											<div style={{ position: "relative" }}>
												Vérification
												<div
													style={{
														position: "absolute",

														top: -3,
														right: -50,
														padding: 0,
													}}
												>
													<Lottie
														options={loadOptions2}
														height={30}
														width={70}
														style={{
															padding: 0,
															fontSize: "20px",
															textAlign: "left",
														}}
													/>
												</div>
											</div>
										</div>
									)}
								</Box>
							) : (
								<div style={{ textAlign: "center" }}>
									<CircularProgress />
								</div>
							)}
						</Box>
					</div>
				) : (
					<div
						style={{
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
						}}
					>
						<Lottie
							options={loadOptions}
							height={80}
							width={80}
						/>
					</div>
				)}
			</div>

			<div className="wrap-conversation-footer">
				{mode === "dark" && (
					<div
						className="absolute-bg"
						style={{
							backgroundColor:
								mode === "dark" ? theme.palette.contentbox.dark : "transparent",
						}}
					></div>
				)}

				{!progressStart && hasSubscription && !hasReachedEnd && (
					<div className="conversation-footer">
						<ResponseUserBox
							onSendResponse={sendResponseUser}
							isDisabled={
								currentMessageQuestion?.question?.type !== EnumQuestionType.OPEN
							}
							theme={theme}
							mode={mode}
						/>
					</div>
				)}
				{!hasSubscription && (
					<div className="conversation-footer">
						<SubscriptionBox
							onSubscribe={() => {
								dispatch(
									setCurrentMenu({ title: "Subscription type", code: 5 })
								);
							}}
							messageSubscription={messageSubscription}
							theme={theme}
						/>
					</div>
				)}
				{hasReachedEnd && (
					<div className="conversation-footer">
						<RestartBox onRestartConversation={restartConversation} />
					</div>
				)}
			</div>
		</div>
	);
}

function ChatBox(props: {
	message: Message;
	currentMessageQuestion?: Message | null;
	onSelectOptionMessage: (message: Message) => void;
	sendMyChoice: (arg0: Message) => void;
	theme: any;
	mode: string;
}) {
	const [message, setMessage] = useState<Message>(props.message);
	const currentMessageQuestion = props.currentMessageQuestion;
	const letters = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J"];
	const [isOptionSelect, setIsOptionSelect] = useState<boolean>(false);
	const [images, setImages] = useState<IMuiFbPhotoGridImage[] | null>();
	const mode = props.mode;
	const theme = props.theme;
	const onSelectOption = (index: number) => {
		let messageUpdate = message;
		let optionEvaluation = messageUpdate.optionsEvaluation![index];
		console.log("Option d'évaluation ", optionEvaluation);
		optionEvaluation.isChecked = !optionEvaluation.isChecked;
		if (index < messageUpdate.optionsEvaluation!.length)
			messageUpdate.optionsEvaluation![index] = optionEvaluation;
		if (messageUpdate.question?.type === EnumQuestionType.SINGLE_CHOICE) {
			for (let i = 0; i < messageUpdate.optionsEvaluation!.length; i++) {
				if (i !== index) {
					console.log("index: ", i);
					let optionEvaluation = messageUpdate.optionsEvaluation![i];
					optionEvaluation.isChecked = false;
					messageUpdate.optionsEvaluation![i] = optionEvaluation;
				}
			}
			if (
				messageUpdate.optionsEvaluation!.filter(
					(element: OptionEvaluation) => element.isChecked === true
				).length > 0
			)
				setIsOptionSelect(true);
			else setIsOptionSelect(false);
		}
		if (messageUpdate.question?.type === EnumQuestionType.MULTI_CHOICE) {
			if (
				messageUpdate.optionsEvaluation!.filter(
					(element: OptionEvaluation) => element.isChecked === true
				).length > 0
			)
				setIsOptionSelect(true);
			else setIsOptionSelect(false);
		}
		setMessage(messageUpdate);
		props.onSelectOptionMessage(messageUpdate);
	};
	const onConfirmChoice = () => {
		props.sendMyChoice(message);
	};
	const formatImages = () => {
		let images: IMuiFbPhotoGridImage[] | null = null;
		if (message.type === EnumAccompanyType.QUESTION) {
			if (message.question?.images && message.question?.images.length > 0) {
				images = message.question?.images.map((element) => {
					return {
						title: "Studa image",
						img: KEYS.HOST_RESOURCE_IMAGE_QUESTION + "/" + element,
					};
				});
			}
		}
		setImages(images);
	};
	useEffect(() => {
		formatImages();
	}, []);

	switch (message.type) {
		case EnumAccompanyType.WELCOME:
			return (
				<Box>
					<div
						className="message-box"
						style={{
							display: "flex",
							justifyContent: "flex-start",
						}}
					>
						<div
							className="content-message"
							style={{
								backgroundColor:
									mode === "dark"
										? theme.palette.backgroundchat.dark
										: theme.palette.backgroundchat.light,
							}}
						>
							<div
								className="triangle-left"
								style={{
									borderTop:
										mode === "dark"
											? `15px solid ${theme.palette.backgroundchat.dark}`
											: `15px solid ${theme.palette.backgroundchat.light}`,
								}}
							></div>
							<div>
								<Typography
									sx={{
										fontSize: 14,
										color:
											mode === "dark"
												? theme.palette.textchat.dark
												: theme.palette.textchat.light,
									}}
									//color="text.secondary"
									gutterBottom
								>
									{message.content?.message}
								</Typography>
							</div>
						</div>
					</div>
				</Box>
			);
		case EnumAccompanyType.CORRECTION:
			return (
				<Box sx={{ pb: 1.5 }}>
					<div
						className="message-box"
						style={{
							display: "flex",
							justifyContent: "flex-start",
						}}
					>
						<div style={{ width: "100%" }}>
							<div style={{ marginBottom: "10px", borderColor: message.content?.color??theme.palette.faildchat.main, }}  className="content-message faild-message">
								<div>
									{/* <Typography
										sx={{
											fontSize: 16,
											color: theme.palette.faildchat.main,
										}}
									>
										{message.content?.faildMessage} -----ici le message
									</Typography> */}
									<Typography
										sx={{
											fontSize: 14,
											color: message.content?.color??theme.palette.faildchat.main,
										}}
										gutterBottom
									>
										{message.content?.message}
									</Typography>
								</div>
							</div>
							{message.content?.answer != null ? (
								<div
									className="content-message correction-message-open"
									style={{
										backgroundColor: theme.palette.primary.main,
										color: theme.palette.colortext.light,
									}}
								>
									<div>
										<Typography
											sx={{
												fontSize: 14,
												color: theme.palette.colortext.dark,
											}}
											gutterBottom
										>
											{message.content?.answer}
										</Typography>
										<Typography
											sx={{
												fontSize: 11,
												color: theme.palette.colortext.dark,
											}}
											gutterBottom
										>
											{message.content?.explanation}
										</Typography>
									</div>
								</div>
							) : (
								message.content?.answers != null &&
								message.content!.answers!.length > 0 && (
									<div
										className="content-message correction-message-choice"
										style={{
											backgroundColor: theme.palette.backgroundPositive.main,
											color: theme.palette.colortext.light,
										}}
									>
										{message.content!.answers.map(
											(answer: any, index: number) => (
												<div key={index}>
													<div style={{ display: "flex" }}>
														<span
															style={{
																fontSize: "12px",
																backgroundColor: theme.palette.primary.main,
																borderRadius: "50%",
																height: "20px",
																width: "20px",
																textAlign: "center",
																display: "flex",
																justifyContent: "center",
																color: "white",
																marginRight: "5px",
																alignContent: "center",
																alignItems: "center",
																verticalAlign: "center",
															}}
														>
															{letters[answer["index"]]}
														</span>
														<Typography
															sx={{
																fontSize: 14,
																color: theme.palette.colortext.light,
															}}
															gutterBottom
														>
															{answer["content"]}
														</Typography>
													</div>
													{answer["explanation"] != null &&
														answer["explanation"] != "" && (
															<Typography
																sx={{
																	fontSize: "0.80rem",
																	color: theme.palette.colortext.light,
																	fontStyle: "italic",
																}}
																gutterBottom
															>
																{answer["explanation"]}
															</Typography>
														)}
												</div>
											)
										)}
									</div>
								)
							)}
						</div>
					</div>
				</Box>
			);
		case EnumAccompanyType.USER_RESPONSE:
			return (
				<Box sx={{ pt: 1, pb: 1 }}>
					<div
						className="message-box"
						style={{
							display: "flex",
							justifyContent: "flex-end",
						}}
					>
						<div
							className="content-message response-message"
							style={{ backgroundColor: mode === "dark"? theme.palette.primary.dark: theme.palette.primary.light }}
						>
							<div
								className="triangle-right"
								style={{
									borderTop: `15px solid ${mode === "dark"? theme.palette.primary.dark: theme.palette.primary.light}`,
								}}
							></div>
							<div>
								<Typography
									sx={{ fontSize: 14, color: theme.palette.colortext.dark }}
									gutterBottom
								>
									{message.content?.content}
								</Typography>
							</div>
						</div>
					</div>
				</Box>
			);
		case EnumAccompanyType.ANSWER:
			return (
				<Box sx={{ pt: 1, pb: 1 }}>
					<div
						className="message-box"
						style={{
							display: "flex",
							justifyContent: "flex-end",
						}}
					>
						<div
							className="content-message response-message"
							style={{ backgroundColor: theme.palette.chatResponse.main }}
						>
							<div
								className="triangle-right"
								style={{
									borderTop: `15px solid ${theme.palette.chatResponse.main}`,
								}}
							></div>
							<div>
								<Typography
									sx={{ fontSize: 14, color: theme.palette.colortext.dark }}
									gutterBottom
								>
									{message.answerString}
								</Typography>
							</div>
						</div>
					</div>
				</Box>
			);
		case EnumAccompanyType.SUCESS_EVALUATION:
			return (
				<Box sx={{ pb: 1.5 }}>
					<div
						className="message-box"
						style={{
							display: "flex",
							justifyContent: "flex-start",
						}}
					>
						<div
							className="content-message success-evaluation"
							style={{
								backgroundColor: message.content?.color??theme.palette.backgroundPositive.main,
								color: theme.palette.colortext.light,
							}}
						>
							<div className=""></div>
							<div>
								<Typography
									sx={{ fontSize: 14, color: theme.palette.colortext.dark }}
									//color="text.secondary"
									gutterBottom
								>
									{message.content?.message}
								</Typography>
							</div>
						</div>
					</div>
				</Box>
			);
		case EnumAccompanyType.FAILED_EVALUATION:
				return (
					<Box sx={{ pb: 1.5 }}>
						<div
							className="message-box"
							style={{
								display: "flex",
								justifyContent: "flex-start",
							}}
						>
							<div
								className="content-message success-evaluation"
								style={{
									backgroundColor: message.content?.color??theme.palette.faildchat.main,
									color: theme.palette.colortext.light,
								}}
							>
								<div className=""></div>
								<div>
									<Typography
										sx={{ fontSize: 14, color: theme.palette.colortext.light }}
										//color="text.secondary"
										gutterBottom
									>
										{message.content?.message}
									</Typography>
								</div>
							</div>
						</div>
					</Box>
				);
		case EnumAccompanyType.QUESTION:
			switch (message.question?.type) {
				case EnumQuestionType.OPEN:
					return (
						<Box>
							<div
								className="message-box"
								style={{
									display: "flex",
									justifyContent: "flex-start",
								}}
							>
								<div style={{ width: "100%" }}>
									<div
										className="content-message"
										style={{
											backgroundColor:
												mode === "dark"
													? theme.palette.backgroundchat.dark
													: theme.palette.backgroundchat.light,
										}}
									>
										<div
											className="triangle-left"
											style={{
												borderTop:
													mode === "dark"
														? `15px solid ${theme.palette.backgroundchat.dark}`
														: `15px solid ${theme.palette.backgroundchat.light}`,
											}}
										></div>
										<div>
											<Typography
												sx={{
													fontSize: 14,
													color:
														mode === "dark"
															? theme.palette.textchat.dark
															: theme.palette.textchat.light,
												}}
												//color="text.secondary"
												gutterBottom
											>
												{message.question?.content}
											</Typography>
										</div>
									</div>
									{images && (
										<div
											style={{
												maxWidth: "400px",
												paddingTop: "5px",
												paddingBottom: "0px",
											}}
										>
											<MuiFbPhotoGrid
												images={images} // require
												reactModalStyle={{ overlay: { zIndex: 2000 } }} // optional (https://github.com/reactjs/react-modal#styles)
											/>
										</div>
									)}
								</div>
							</div>
						</Box>
					);
				case EnumQuestionType.SINGLE_CHOICE:
					return (
						<Box>
							<div
								className="message-box"
								style={{
									display: "flex",
									justifyContent: "flex-start",
								}}
							>
								<div style={{ width: "100%" }}>
									<div
										className="content-message"
										style={{
											backgroundColor:
												mode === "dark"
													? theme.palette.backgroundchat.dark
													: theme.palette.backgroundchat.light,
										}}
									>
										<div
											className="triangle-left"
											style={{
												borderTop:
													mode === "dark"
														? `15px solid ${theme.palette.backgroundchat.dark}`
														: `15px solid ${theme.palette.backgroundchat.light}`,
											}}
										></div>
										<div>
											<Typography
												sx={{
													fontSize: 14,
													color:
														mode === "dark"
															? theme.palette.textchat.dark
															: theme.palette.textchat.light,
												}}
												//color="text.secondary"
												gutterBottom
											>
												{message.question?.content}
											</Typography>
										</div>
									</div>
									{images && (
										<div
											style={{
												maxWidth: "400px",
												paddingTop: "5px",
												paddingBottom: "0px",
											}}
										>
											<MuiFbPhotoGrid
												images={images} // require
												reactModalStyle={{ overlay: { zIndex: 2000 } }} // optional (https://github.com/reactjs/react-modal#styles)
											/>
										</div>
									)}
									<div className="wrap-options-evaluation">
										{message.optionsEvaluation?.map((optionEvaluation, i) => (
											<Button
												key={i}
												variant="outlined"
												className="option-evaluation"
												disabled={message !== currentMessageQuestion}
												startIcon={
													<span
														style={{
															fontSize: "13px",
															backgroundColor: optionEvaluation.isChecked
																? "white"
																: theme.palette.chatResponse.main,
															borderRadius: "50%",
															height: "20px",
															width: "20px",
															textAlign: "center",
															color: optionEvaluation.isChecked
																? theme.palette.chatResponse.main
																: "white",
														}}
													>
														{letters[i]}
													</span>
												}
												sx={{
													fontSize: "13px",
													fontWeight: "400",
													backgroundColor: optionEvaluation.isChecked
														? theme.palette.chatResponse.main
														: "white",
													color: optionEvaluation.isChecked
														? "white"
														: theme.palette.chatResponse.main,
													"&.Mui-disabled": {
														color: optionEvaluation.isChecked
															? "white"
															: "rgba(0, 0, 0, 0.26)",
														border: "none",
														fontWeight: 400,
													},
													"&:hover": {
														/*backgroundColor: '#fff',
														color: '#3c52b2',*/
														border: "none",
													},
													border: "none",
												}}
												onClick={() => {
													onSelectOption(i);
												}}
											>
												{optionEvaluation.content}
											</Button>
										))}
									</div>
								</div>
							</div>
							{isOptionSelect &&
								currentMessageQuestion?.messageId === message.messageId && (
									<div
										style={{
											paddingLeft: "10px",
											paddingTop: "5px",
										}}
									>
										<Button
											variant="contained"
											endIcon={<Send />}
											sx={{
												textTransform: "none",
												borderRadius: "15px",
											}}
											onClick={onConfirmChoice}
										>
											Confirmer mon choix
										</Button>
									</div>
								)}
						</Box>
					);
				case EnumQuestionType.MULTI_CHOICE:
					return (
						<Box>
							<div
								className="message-box"
								style={{
									display: "flex",
									justifyContent: "flex-start",
								}}
							>
								<div style={{ width: "100%" }}>
									<div
										className="content-message"
										style={{
											backgroundColor:
												mode === "dark"
													? theme.palette.backgroundchat.dark
													: theme.palette.backgroundchat.light,
										}}
									>
										<div
											className="triangle-left"
											style={{
												borderTop:
													mode === "dark"
														? `15px solid ${theme.palette.backgroundchat.dark}`
														: `15px solid ${theme.palette.backgroundchat.light}`,
											}}
										></div>
										<div>
											<Typography
												sx={{
													fontSize: 14,
													color:
														mode === "dark"
															? theme.palette.textchat.dark
															: theme.palette.textchat.light,
												}}
												//color="text.secondary"
												gutterBottom
											>
												{message.question?.content}
											</Typography>
										</div>
									</div>
									{images && (
										<div
											style={{
												maxWidth: "400px",
												paddingTop: "5px",
												paddingBottom: "0px",
											}}
										>
											<MuiFbPhotoGrid
												images={images} // require
												reactModalStyle={{ overlay: { zIndex: 2000 } }} // optional (https://github.com/reactjs/react-modal#styles)
											/>
										</div>
									)}
									{/*<div>Sélectionne les options justes</div>*/}
									<div className="wrap-options-evaluation">
										{message.optionsEvaluation?.map((optionEvaluation, i) => (
											<Button
												key={i}
												variant="outlined"
												className="option-evaluation"
												disabled={message !== currentMessageQuestion}
												startIcon={
													<span
														style={{
															fontSize: "13px",
															backgroundColor: optionEvaluation.isChecked
																? "white"
																: theme.palette.chatResponse.main,
															borderRadius: "50%",
															height: "20px",
															width: "20px",
															textAlign: "center",
															color: optionEvaluation.isChecked
																? theme.palette.chatResponse.main
																: "white",
														}}
													>
														{letters[i]}
													</span>
												}
												sx={{
													fontSize: "13px",
													fontWeight: "400",
													backgroundColor: optionEvaluation.isChecked
														? theme.palette.chatResponse.main
														: "white",
													color: optionEvaluation.isChecked
														? "white"
														: theme.palette.chatResponse.main,
													"& .MuiButton-endIcon": {
														position: "absolute",
														right: "1rem",
													},
													"&.Mui-disabled": {
														color: optionEvaluation.isChecked
															? "white"
															: "rgba(0, 0, 0, 0.26)",
														border: "none",
														fontWeight: 400,
													},
													"&:hover": {
														/*backgroundColor: '#fff',
														color: '#3c52b2',*/
														border: "none",
													},
													border: "none",
												}}
												onClick={() => {
													onSelectOption(i);
												}}
											>
												{optionEvaluation.content}
											</Button>
										))}
									</div>
								</div>
							</div>
							{isOptionSelect &&
								currentMessageQuestion?.messageId === message.messageId && (
									<div
										style={{
											paddingLeft: "10px",
											paddingTop: "5px",
										}}
									>
										<Button
											variant="contained"
											endIcon={<Send />}
											sx={{
												textTransform: "none",
												borderRadius: "15px",
												backgroundColor: theme.palette.chatResponse.main,
												color:
													mode === "dark"
														? theme.palette.colortext.dark
														: theme.palette.colortext.light,
											}}
											onClick={onConfirmChoice}
										>
											Confirmer mes choix
										</Button>
									</div>
								)}
						</Box>
					);

				default:
					return <></>;
			}
			break;
		case EnumAccompanyType.SUBSCRIPTION_INFO:
			return (
				<Box>
					<div
						className="message-box"
						style={{
							display: "flex",
							justifyContent: "flex-start",
						}}
					>
						<div
							className="content-message"
							style={{
								backgroundColor:
									mode === "dark"
										? theme.palette.backgroundchat.dark
										: theme.palette.backgroundchat.light,
							}}
						>
							<div
								className="triangle-left"
								style={{
									borderTop:
										mode === "dark"
											? `15px solid ${theme.palette.backgroundchat.dark}`
											: `15px solid ${theme.palette.backgroundchat.light}`,
								}}
							></div>
							<div>
								<Typography
									sx={{
										fontSize: 14,
										color:
											mode === "dark"
												? theme.palette.textchat.dark
												: theme.palette.textchat.light,
									}}
									//color="text.secondary"
									gutterBottom
								>
									{message.content?.message}
								</Typography>
							</div>
						</div>
					</div>
				</Box>
			);
		default:
			return <></>;
	}
}
function ResponseUserBox(props: {
	onSendResponse: (value: UserResponse) => void;
	isDisabled: boolean;
	theme: any;
	mode: string;
}) {
	const [answer, setAnswer] = useState<string>("");
	const onChange = (value: string) => {
		setAnswer(value);
	};
	const onSendResponse = () => {
		let userResponse: UserResponse = new UserResponse();
		userResponse.content = answer;
		props.onSendResponse(userResponse);
		setAnswer("");
	};
	const handleKeypress = (e: React.KeyboardEvent) => {
		//it triggers by pressing the enter key
		console.log(e.key === "Enter");
		if (e.key === "Enter") {
			onSendResponse();
		}
	};
	const theme = props.theme;
	const mode = props.mode;
	return (
		<div
			className="wresponse-box"
			style={{
				paddingTop: "12px",
				paddingBottom: "11px",
				paddingLeft: "15px",
				paddingRight: "15px",
				display: "flex",
			}}
		>
			<Box sx={{ width: "100%", display: "flex" }}>
				<div
					style={{
						display: "flex",
						alignItems: "center",
						justifyContent: "space-between",
						width: "100%",
					}}
				>
					<Stack
						direction="column"
						spacing={1}
						style={{
							display: "flex",
							alignItems: "center",

							width: "100%",
						}}
					>
						<div
							className=""
							style={{
								display: "flex",
								flex: "1 1 auto",
								width: "90%",
								boxShadow: "rgba(149, 157, 165, 0.2) 0px 8px 24px",
							}}
						>
							<OutlinedInput
								size="small"
								disabled={props.isDisabled}
								style={{
									backgroundColor:
										mode === "dark"
											? theme.palette.backgroundchat.dark
											: "white",
									width: "100%",
									paddingTop: "5px",
									paddingBottom: "5px",
									borderRadius: "8px",
									color:
										mode === "dark"
											? theme.palette.colortext.dark
											: theme.palette.colortext.light,
								}}
								sx={{
									"& .MuiOutlinedInput-notchedOutline": {
										//border: "1px solid red",
									},
									"&.MuiOutlinedInput-root.Mui-focused": {
										".MuiOutlinedInput-notchedOutline": {
											border: "none",
										},
									},
									"&.MuiOutlinedInput-root.Mui-disabled": {
										color:
											mode === "dark"
												? `${theme.palette.colortext.dark} !important`
												: "rgba(0, 0, 0, 0.8)",
										//color: "rgba(0, 0, 0, 0.26)",
										border: "none",
										fontWeight: 400,
									},
									//label: { color: "red" },
								}}
								placeholder={
									props.isDisabled
										? "Sélectionnez la réponse ou les réponses justes..."
										: "Entrez votre réponse ici..."
								}
								id="outlined-adornment-password"
								type={"text"}
								value={answer}
								onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
									onChange(event.target.value);
								}}
								onKeyPress={(event: React.KeyboardEvent) => {
									handleKeypress(event);
								}}
								endAdornment={
									<InputAdornment position="end">
										<IconButton
											disabled={props.isDisabled}
											aria-label="toggle password visibility"
											onClick={onSendResponse}
											onMouseDown={() => {}}
											edge="end"
										>
											<SendOutlined
												style={{
													transform: "rotate(-45deg)",
													fontSize: "18px",
													color:
														mode === "dark"
															? theme.palette.colortext.dark
															: theme.palette.colortext.light,
												}}
											/>
										</IconButton>
									</InputAdornment>
								}
							/>
						</div>
						<div
							className="copy-right"
							style={{
								color:
									mode === "dark"
										? theme.palette.colortext.dark
										: theme.palette.colortext.light,
							}}
						>
							Copyright (c) 2022 Studa All rights reserved
						</div>
					</Stack>
					<Stack
						direction="row"
						spacing={1}
						style={{
							display: "flex",
							alignItems: "center",
						}}
					></Stack>
				</div>
			</Box>
		</div>
	);
}

function SubscriptionBox(props: {
	onSubscribe: () => void;
	messageSubscription: Message[];
	theme: any;
}) {
	const theme = props.theme;
	return (
		<div
			className="subscription-box"
			style={
				{
					//backgroundColor: theme.palette.backgroundPositive.main,
					//color: theme.palette.colortext.light,
				}
			}
		>
			<Stack
				direction="column"
				className="content-subscription"
				style={
					{
						// backgroundColor: theme.palette.backgroundPositive.main,
						// color: theme.palette.colortext.light,
					}
				}
			>
				<div>Cette conversation requiert un abonnement</div>
				<div style={{ width: "100%", paddingTop: "5px" }}>
					<Button
						variant="outlined"
						startIcon={<WorkspacePremium />}
						sx={{
							textTransform: "none",
							width: "100%",
							backgroundColor: theme.palette.backgroundPositive.main,
							color: theme.palette.colortext.light,
							"&:hover": {
								backgroundColor: "#4caf50",
								border: "none",
							},
							border: "none",
							boxShadow: "none !important",
							paddingTop: "8px",
							paddingBottom: "8px",
						}}
						onClick={() => props.onSubscribe()}
					>
						{props.messageSubscription[0].type ===
						EnumAccompanyType.SUBSCRIPTION
							? props.messageSubscription[0].content?.message
							: props.messageSubscription[1].content?.message}
					</Button>
				</div>
			</Stack>
		</div>
	);
}

function RestartBox(props: { onRestartConversation: () => void }) {
	return (
		<div className="subscription-box">
			<Stack
				direction="column"
				className="content-subscription"
			>
				<div>Vous êtes arrivé à la fin de cette conversation</div>
				<div style={{ width: "100%", paddingTop: "5px" }}>
					<Button
						variant="outlined"
						startIcon={<RestartAlt />}
						sx={{
							textTransform: "none",
							width: "100%",
							backgroundColor: "#2e7d32",
							color: "white",
							"&:hover": {
								backgroundColor: "#4caf50",
								border: "none",
							},
							border: "none",
							boxShadow: "none !important",
							paddingTop: "8px",
							paddingBottom: "8px",
						}}
						onClick={props.onRestartConversation}
					>
						Redémarrer la conversation
					</Button>
				</div>
			</Stack>
		</div>
	);
}
export default ConversationScreen;
